import { render } from "./Hero.vue?vue&type=template&id=67599d4a&scoped=true&ts=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=67599d4a&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67599d4a"]])

export default __exports__